export abstract class BaseFilterRequest {
    sortingKey?: string;
    sortingDirectionAsc?: boolean;
    from?: number;
    amount?: number;
}
